import { FC } from 'react'
import { Layout } from '../../components'
import { useEnrollmentRoute } from './use-enrollment-route'

export const EnrollmentRoute: FC = () => {
  useEnrollmentRoute()

  return (
    <Layout>
      <div id="root-enrollment-redirect" />
    </Layout>
  )
}
